import { useTranslation } from "react-i18next";
import axios, { AxiosError } from "axios";
import { useSnackbar } from "notistack";
import { isArray } from "lodash";

type Callback = (error: Error) => void

export function useShowError(): Callback {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    return (error) => {
        function isAxiosError(error: Error | AxiosError): error is AxiosError {
            return Boolean((error as AxiosError).response);
        }
        if (isAxiosError(error)) {
            if (error.response) {
                if (error.response.status === 400 || error.response.status === 404) {
                    if (typeof error.response.data === 'string') {
                        if (error.response.data.length < 200) {
                            enqueueSnackbar(error.response.data, { variant: 'error' });
                        } else {
                            enqueueSnackbar(error.response.status === 404 ? t('errors.not-found') : t('errors.bad-request'), { variant: 'error' });
                        }
                    } else if (isArray(error.response.data)) {
                        error.response.data.forEach(error => {
                            if (typeof error === 'string') {
                                enqueueSnackbar(error, { variant: 'error' });
                            }
                            if (typeof error === 'object') {
                                for (const [key, value] of Object.entries(error)) {
                                    const keyText = t(`shared.${key}`);
                                    if (Array.isArray(value)) {
                                        value.map(error => enqueueSnackbar(`${keyText} : ${error}`, { variant: 'error' }));
                                    } else {
                                        enqueueSnackbar(`${keyText} : ${value}`, { variant: 'error' });
                                    }
                                }
                            }
                        });
                    } else if (typeof error.response.data === 'object') {
                        for (const [key, value] of Object.entries(error.response.data)) {
                            const keyText = t(`shared.${key}`);
                            if (Array.isArray(value)) {
                                value.map(error => enqueueSnackbar(`${keyText} : ${error}`, { variant: 'error' }));
                            } else {
                                enqueueSnackbar(`${keyText} : ${value}`, { variant: 'error' });
                            }
                        }
                    }
                } else if (error.response.status === 401 || error.response.status === 403) {
                    // L'API renvoie un motif explicite dans `message` (quota depasse, etc.) et c'est a
                    // elle de le traduire. Un refus de permission passe par DRF, qui renvoie `detail` :
                    // on garde alors le libelle traduit plutot que la phrase anglaise par defaut.
                    const message = (error.response.data as { message?: unknown } | null)?.message;
                    enqueueSnackbar(
                        typeof message === 'string' && message.trim() !== '' ? message : t('errors.permissions'),
                        { variant: 'error' }
                    );
                } else if (error.response.status === 409) {
                    enqueueSnackbar(t('errors.conflict') + ': ' + error.response.data?.error, { variant: 'error' });
                } else if (error.response.status === 500) {
                    enqueueSnackbar(t('errors.servers'), { variant: 'error' });
                }
            }
            console.log('error.config : ', error.config);
        } else {
            if (!axios.isCancel(error)) {
                enqueueSnackbar(error.message, { variant: 'error' });
            }
        }
    };
}